import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=69f4bbb6&scoped=true"
import script from "./merchant.vue?vue&type=script&lang=js"
export * from "./merchant.vue?vue&type=script&lang=js"
import style0 from "./merchant.vue?vue&type=style&index=0&id=69f4bbb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f4bbb6",
  null
  
)

export default component.exports